import React from 'react';
import { Link } from 'react-router-dom';

const Hero = () => {
  return (
    <section className="relative h-screen w-full flex items-center justify-center overflow-hidden bg-black">
      {/* 1. Video de Fondo */}
      <video
        autoPlay
        loop
        muted
        playsInline
        className="absolute z-10 w-auto min-w-full min-h-full max-w-none object-cover opacity-40"
      >
        <source src="/video-pabs-proceso.mp4" type="video/mp4" />
      </video>

      {/* Capa de oscurecimiento */}
      <div className="absolute inset-0 bg-black/40 z-20"></div>

      {/* 2. Contenedor Central */}
      <div className="relative z-30 text-center px-4 max-w-5xl flex flex-col items-center">
        
        {/* LOGO CIRCULAR CENTRADO */}
        <div className="mb-6 flex justify-center">
          <div className="h-28 w-28 md:h-36 md:w-36 rounded-full border-4 border-yellow-400 overflow-hidden shadow-2xl bg-white flex items-center justify-center">
            <img 
              src="/logo-pabs.png" 
              alt="Logo PABS" 
              className="h-full w-full object-contain p-2 rounded-full"
            />
          </div>
        </div>

        {/* TÍTULO EN AMARILLO */}
        <h1 className="text-white text-5xl md:text-7xl font-black mb-6 leading-tight tracking-tighter uppercase italic">
          Previsión <span className="text-yellow-400 shadow-yellow-400/20">PABS</span>
        </h1>
        
        <p className="text-gray-100 text-xl md:text-2xl max-w-3xl mx-auto mb-10 font-medium drop-shadow-md">
          Protección inmediata para tu familia con el Programa de Apoyo de Beneficio Social.
        </p>

        <div className="flex flex-col md:flex-row gap-4 justify-center">
          {/* Este botón baja al formulario en la misma página */}
          <a 
            href="#registro" 
            className="bg-yellow-400 hover:bg-yellow-500 text-black px-12 py-4 rounded-full font-black uppercase tracking-widest transition-all transform hover:scale-105 shadow-xl shadow-yellow-400/20"
          >
            INICIAR AFILIACIÓN
          </a>

          {/* ESTA ES LA CONEXIÓN A LA NUEVA PÁGINA */}
          <Link 
            to="/planes" 
            className="border-2 border-white/80 hover:bg-white hover:text-black text-white px-12 py-4 rounded-full font-black uppercase tracking-widest transition-all backdrop-blur-sm"
          >
            Ver Planes Detallados
          </Link>
        </div>
      </div>
    </section>
  );
};

export default Hero;